import { render, staticRenderFns } from "./BasicElementsSection.vue?vue&type=template&id=cfdce37e&scoped=true&"
import script from "./BasicElementsSection.vue?vue&type=script&lang=js&"
export * from "./BasicElementsSection.vue?vue&type=script&lang=js&"
import style0 from "./BasicElementsSection.vue?vue&type=style&index=0&id=cfdce37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdce37e",
  null
  
)

component.options.__file = "BasicElementsSection.vue"
export default component.exports